import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, vModelCheckbox as _vModelCheckbox, withDirectives as _withDirectives, normalizeClass as _normalizeClass, vShow as _vShow } from "vue"

const _hoisted_1 = /*#__PURE__*/_createElementVNode("i", {
  style: {"font-size":"20px","white-space":"nowrap"},
  class: "fas fa-info-circle"
}, null, -1)
const _hoisted_2 = { style: {"text-align":"justify"} }
const _hoisted_3 = /*#__PURE__*/_createElementVNode("hr", null, null, -1)
const _hoisted_4 = /*#__PURE__*/_createElementVNode("br", null, null, -1)
const _hoisted_5 = /*#__PURE__*/_createElementVNode("br", null, null, -1)
const _hoisted_6 = { class: "row justify-content-center" }
const _hoisted_7 = ["id", "onUpdate:modelValue"]
const _hoisted_8 = ["onClick"]
const _hoisted_9 = /*#__PURE__*/_createElementVNode("br", null, null, -1)
const _hoisted_10 = /*#__PURE__*/_createElementVNode("br", null, null, -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("h5", null, [
      _hoisted_1,
      _createTextVNode(" " + _toDisplayString(_ctx.$t("messages.form vocabulary pairs")), 1)
    ]),
    _createElementVNode("p", _hoisted_2, _toDisplayString(_ctx.$t("messages.Form vocabulary pairs")), 1),
    _hoisted_3,
    _hoisted_4,
    _hoisted_5,
    _createElementVNode("div", _hoisted_6, [
      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.clusterElements, (element) => {
        return _withDirectives((_openBlock(), _createElementBlock("div", {
          key: element.vocab.id,
          class: "text-center px-1 col-4"
        }, [
          _withDirectives(_createElementVNode("input", {
            type: "checkbox",
            id: 'element'+element.vocab.id,
            "onUpdate:modelValue": ($event: any) => (element.checked = $event),
            autocomplete: "off",
            style: {"display":"none"}
          }, null, 8, _hoisted_7), [
            [_vModelCheckbox, element.checked]
          ]),
          _createElementVNode("label", {
            class: _normalizeClass(["btn", [element.incorrect ? 'btn-danger' : element.checked ? 'btn-primary' : 'btn-outline-primary']]),
            onClick: ($event: any) => (_ctx.check(element))
          }, _toDisplayString(element.vocab.name), 11, _hoisted_8)
        ], 512)), [
          [_vShow, element.visible]
        ])
      }), 128))
    ]),
    _hoisted_9,
    _hoisted_10
  ], 64))
}